import React from "react";

import { yellow400 } from "../../lib/themes/colors";
import { bidPart, pipelinePart, strategyPart, tenderPart } from "./CustomIcons";

type Props = {
  fill?: string;
  className?: string;
};

export function BasicPlan({ fill = yellow400, className }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={className} fill="none">
      <g id="Geometric">
        <path
          id="Rectangle 301"
          opacity="0.8"
          d="M0 16C-1.93129e-07 11.5817 3.58172 8 8 8L8 16L0 16Z"
          fill={fill}
        />
        <path
          id="Rectangle 302"
          opacity="0.4"
          d="M16 8C16 12.4183 12.4183 16 8 16L8 8L16 8Z"
          fill={fill}
        />
        <path
          id="Rectangle 303"
          opacity="0.9"
          d="M8 0C12.4183 0 16 3.58172 16 8L8 8V0Z"
          fill={fill}
        />
        <path
          id="Rectangle 304"
          opacity="0.6"
          d="M0 0C4.41828 0 8 3.58172 8 8L0 8L0 0Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export const planIcons = {
  basic: <BasicPlan />,
};

export const strategyIcons = {
  bidPart,
  tenderPart,
  pipelinePart,
  strategyPart,
};

export const paidIcons = {
  ...planIcons,
  ...strategyIcons,
};
